'use strict';

const ContactUIStore = require('../stores/ContactUIStore');
const ContactGaStore = require('../stores/ContactGaStore');
const ContactMessageStore = require('../stores/ContactMessageStore');
const PurchaseTracking = require('../../../global/mixins/purchaseTracking.es');
const tracking = require('dibs-tracking');
const currencyUtil = require('dibs-currency-helpers/util');
const undefined = void 0;

const actions = (module.exports = {
    eventOfferEnable(actionContext) {
        const data = actionContext.getStore(ContactGaStore).data;

        // Tracking (E-commerce + make offer click)
        // Note: E-commerce tracking must precede event tracking
        new PurchaseTracking({
            item: data.item,
        }).ecommerceAddToCartTracking();
        tracking.trackEvent({
            category: 'make offer click',
            action: 'contact dealer modal',
            label: data.purchaseStatus,
        });
    },

    eventOfferSuccess(actionContext, { isOfferLow }) {
        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'offer initiated',
            label: isOfferLow ? 'below asking price' : 'within range',
        });
    },

    eventOfferSuccessPreN2(actionContext, { isOfferLow }) {
        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'continue offer',
            label: isOfferLow ? 'below asking price' : 'within range',
        });
    },

    eventOfferSuccessPreN2WithLowballOptions(actionContext, { offerAmount }) {
        const { selectedLowballOption, priceValue } = actionContext.getStore(ContactUIStore).state;
        let isOther = false;
        let isOriginalOffer = false;
        let percentage;
        if (selectedLowballOption) {
            isOther = selectedLowballOption.isOther;
            isOriginalOffer = selectedLowballOption.isOriginalOffer;
            percentage = 100 - selectedLowballOption.percentOff;
        } else {
            const offerValue = currencyUtil.parseFloat(offerAmount);
            percentage = offerValue / priceValue * 100;
        }
        const labelPartOne = selectedLowballOption && !isOriginalOffer ? 'revised' : 'initial';
        const labelPartTwo = !selectedLowballOption || isOther ? 'custom' : 'preset';
        let bucket;
        if (percentage === 100) {
            bucket = '100%';
        } else if (percentage > 90 && percentage < 100) {
            bucket = '91-99%';
        } else if (percentage > 80 && percentage <= 90) {
            bucket = '81-90%';
        } else if (percentage > 70 && percentage <= 80) {
            bucket = '71-80%';
        } else if (percentage > 60 && percentage <= 70) {
            bucket = '61-70%';
        } else if (percentage > 50 && percentage <= 60) {
            bucket = '51-60%';
        } else if (percentage > 40 && percentage <= 50) {
            bucket = '41-50%';
        } else if (percentage > 30 && percentage <= 40) {
            bucket = '31-40%';
        } else if (percentage > 20 && percentage <= 30) {
            bucket = '21-30%';
        } else if (percentage > 10 && percentage <= 20) {
            bucket = '11-20%';
        } else {
            bucket = '1-10%';
        }
        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'continue offer',
            label: `${labelPartOne}|${labelPartTwo}|${bucket}`,
        });
    },

    eventOfferError(actionContext, { errorMessage, source }) {
        tracking.trackEvent({
            category: 'form error',
            action: `make offer|${source} form|offer amount`,
            label: errorMessage,
        });
    },

    eventLaunch(actionContext) {
        tracking.trackEvent(
            Object.assign(actions.contactDealerBaseOptions(actionContext), {
                action: 'contact dealer clicked',
            })
        );
    },

    eventContactSuccess(actionContext, { isOptIn }) {
        const baseOptions = actions.contactDealerBaseOptions(actionContext);
        const options = {
            action: 'contact dealer submitted',
            value: isOptIn ? 1 : 0,
        };
        if (actionContext.getStore(ContactGaStore).data.linkLocation === 'finding') {
            options.label = 'contact link in results – request price button';
        }
        tracking.trackEvent(Object.assign({}, baseOptions, options));
    },

    eventSend(actionContext) {
        const baseOptions = actions.contactDealerBaseOptions(actionContext);
        const { isOfferEnabled } = actionContext.getStore(ContactUIStore).state;
        const options = {
            action: 'contact dealer send clicked',
            value: isOfferEnabled ? 1 : 0,
        };
        if (actionContext.getStore(ContactGaStore).data.linkLocation === 'finding') {
            options.label = 'contact link in results – request price button';
        }
        tracking.trackEvent(Object.assign({}, baseOptions, options));
    },

    netPriceEventSend(actionContext) {
        new PurchaseTracking({
            pageContext: 'pdp',
            item: actionContext.getStore(ContactMessageStore).message.get('item'),
        }).trackNetPriceEvent({ actionSuffix: 'submitted' });
    },

    pageView(actionContext, { isSuccess }) {
        const data = actionContext.getStore(ContactGaStore).data;
        const urlEnd = `${isSuccess ? 'complete' : 'form'}-${data.isItem ? 'item' : 'general'}`;
        const url = ['', 'vpv', 'contact-dealer', urlEnd, ''].join('/') + '?' + data.vpvParamsQuery;

        // this prevents re-firing of any ecommerce events that already happened
        tracking.addGTMMessage({ ecommerce: undefined });
        tracking.trackPageview({
            url,
            additional: {
                pageType: 'Other',
                pageSubType: 'Contact Dealer Modal',
            },
        });
    },

    contactDealerBaseOptions(actionContext) {
        const data = actionContext.getStore(ContactGaStore).data;
        return {
            category: 'contact dealer',
            label: data.linkLocation,
        };
    },

    constants: {
        contactFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'contact dealer confirmation modal',
        },

        netPriceFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'net price confirmation modal',
        },

        offerFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'make offer confirmation modal',
        },

        contactOmtLinkParams: {
            category: 'contact dealer',
            action: 'contact dealer form interaction',
            label: 'view offer in bomt',
        },

        netPriceOmtLinkParams: {
            category: 'net price',
            action: 'net price form interaction',
            label: 'view offer in bomt',
        },

        offerOmtLinkParams: {
            category: 'make offer form interaction',
            action: 'view offer in bomt',
        },
    },
});



// WEBPACK FOOTER //
// ./assets/js/contact/shared/actions/gaActions.es.js